export default __webpack_public_path__ + "static/media/cancel.44272203.svg";